module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audience-hub-dashboard-header"
  }, [_c('v-row', {
    staticClass: "audience-hub-dashboard-header__title-area"
  }, [_c('v-col', {
    staticClass: "audience-hub-dashboard-header__title"
  }, [_c('v-img', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "max-width": "32",
      "src": _vm.amHeader()
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_vm._v("Audience Matters")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "audience-hub-dashboard-header__right-area"
  }, [(_vm.showUserProfile) ? _c('span', {
    staticClass: "audience-hub-dashboard-header__user-profile"
  }, [_vm._v("\n        " + _vm._s(_vm.userRoles) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('span', [_c('new-item-menu', {
    staticClass: "audience-hub-dashboard-header__new-item",
    on: {
      "select": function (val) { return _vm.handleNewItemMenuClick(val); }
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "audience-hub-dashboard-header__notifications"
  }, [_c('audience-matters-notifications')], 1), _vm._v(" "), _c('span', {
    staticClass: "audience-hub-dashboard-header__username",
    class: {
      headerMenuClickable: _vm.doesUserHaveAdminPermissions
    },
    on: {
      "click": _vm.expandHeaderMenu
    }
  }, [_vm._v("\n        " + _vm._s(_vm.username) + "\n      ")])])], 1), _vm._v(" "), _c('stepper-modal'), _vm._v(" "), _c('send-downstream', {
    ref: "sendDownstreamModal",
    attrs: {
      "value": _vm.initialTargetCopy
    }
  }), _vm._v(" "), _c('request-video-amp-segment', {
    model: {
      value: (_vm.isRequestVideoAmpSegmentDialogOpen),
      callback: function($$v) {
        _vm.isRequestVideoAmpSegmentDialogOpen = $$v
      },
      expression: "isRequestVideoAmpSegmentDialogOpen"
    }
  }), _vm._v(" "), _c('retargeting-request', {
    model: {
      value: (_vm.isRetargetingRequestDialogOpen),
      callback: function($$v) {
        _vm.isRetargetingRequestDialogOpen = $$v
      },
      expression: "isRetargetingRequestDialogOpen"
    }
  }), _vm._v(" "), [_c('modal', {
    ref: "modal",
    attrs: {
      "title": "Select Intent",
      "width": 500,
      "closeButton": "",
      "hideActions": ""
    }
  }, [
    [_c('div', {
      staticClass: "audience-hub-dashboard-header__select-intent-actions"
    }, [(_vm.intents.some(function (v) { return v === _vm.Sales; })) ? _c('action-button', {
      attrs: {
        "dark": "",
        "label": "Sales",
        "color": "primary",
        "id": "salesIntent"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.intentSelected(_vm.Sales)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.intents.some(function (v) { return v === _vm.Marketing; })) ? _c('action-button', {
      attrs: {
        "dark": "",
        "label": "Marketing",
        "color": "primary",
        "id": "marketingIntent"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.intentSelected(_vm.Marketing)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.intents.some(function (v) { return v === _vm.Research; })) ? _c('action-button', {
      attrs: {
        "dark": "",
        "label": "Research",
        "color": "primary",
        "id": "researchIntent"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.intentSelected(_vm.Research)
        }
      }
    }) : _vm._e()], 1)]
  ], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ffae599"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/common/AudienceHubDashboardHeader.vue
// module id = 1942
// module chunks = 0